import { render, staticRenderFns } from "./AddGolfServiceRetail.vue?vue&type=template&id=df1c5b38"
import script from "./AddGolfServiceRetail.js?vue&type=script&lang=js&external"
export * from "./AddGolfServiceRetail.js?vue&type=script&lang=js&external"
import style0 from "./AddGolfServiceRetail.vue?vue&type=style&index=0&id=df1c5b38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports